
<!--新建联系人与编辑联系人的对话框-->
<template>
<div>
    <el-dialog :title="title" :visible.sync="isShow"  :before-close="handleClose" center top="100px">
        <el-form ref="form" :model="form" :rules="rules">

            <el-row>

                <el-col :span="24">
                    <el-form-item v-if="isUpdateCustomerName"  label="客户名称" prop="customer_name" :label-width="formLabelWidth"  >
                        <!-- <CustomerSelect
                            :onlyShow="onlyShow"
                            :customerIdss="customerName"
                            :customerId="customerId"
                            @change="CustomerHandleChange($event)">
                        </CustomerSelect> -->
                        <el-input
                                placeholder="请选择客户"
                                :disabled="true"
                                v-model="form.customer_name"
                                auto-complete="off" >
                            <el-button slot="append" icon="el-icon-search" @click="showCustomerFilter = true" >选择客户</el-button>
                        </el-input>
                    </el-form-item>

                    <el-form-item v-if="isShowCustomerName"   label="客户名称" :label-width="formLabelWidth" prop="customer_name" >
                        <el-input
                                placeholder="请选择客户"
                                :disabled="true"
                                v-model="customerName"
                                auto-complete="off" >
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
                        <el-input v-model="form.name" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="手机" prop="mobile" :label-width="formLabelWidth">
                        <el-input v-model="form.mobile" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="电话号码" prop="phone_number" :label-width="formLabelWidth">
                        <el-input v-model="form.phone_number" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="QQ" prop="qq" :label-width="formLabelWidth">
                        <el-input v-model="form.qq" auto-complete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人类型" prop="type" :label-width="formLabelWidth">
                        <el-select v-if="types" v-model="form.type" placeholder="请选择类型" >
                            <el-option v-for="(item, key) in types" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人职务" prop="job" :label-width="formLabelWidth" class="inline-item">
                        <el-select v-if="jobs" v-model="form.job" placeholder="请选择类型" >
                            <el-option v-for="(item, key) in jobs" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                        <el-input v-if="form.job==4" v-model="form.job_name" style="width:120px" class="inline-input" @input="change($event)"></el-input>
                    </el-form-item>
                    <el-form-item label="关键联系人" prop="status" :label-width="formLabelWidth">
                        <el-select v-if="statuses" v-model="form.status" placeholder="请选择类型" >
                            <el-option v-for="(item, key) in statuses" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                        <span style="color:#c0c4cc; font-size:12px;" >（一个客户只有一个关键联系人）</span>
                    </el-form-item>
                    <el-form-item label="推荐人" prop="parent_id" :label-width="formLabelWidth">
                        <el-select v-model="form.parent_id" placeholder="请选择联系人" :disabled="form.parent_id == 0 && form.leads_id > 0">
                            <el-option v-for="item in contactsList" :key="item.id + ''" :label="item.name" :value="item.id + ''" v-show="item.leads_id && form.id != item.id || form.parent_id == item.id">
                            </el-option>
                            <el-option key="0" label="无" value="0">
                            </el-option>
                        </el-select>
                        <el-tooltip content="直接或间接提供新增联系人信息的用户。" placement="top">
                            <i class="el-icon-warning-outline"></i>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item v-show="myProducts"  label="意向产品" prop="products" :label-width="formLabelWidth">
                <el-checkbox-group v-model="form.products" class="product-use">
                    <el-checkbox v-for="product in myProducts" :key="product.id" :label="product.id">{{product.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="备注" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.memo" auto-complete="off"></el-input>
            </el-form-item>



        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取 消</el-button>
            <el-button type="primary" @click="submitForm('form')" :loading="loading">确 定</el-button>
        </div>

    </el-dialog>
    <customer-filter v-if="showCustomerFilter"
        :show-dialog = "showCustomerFilter"
        :modal = 'false'
        :filter-is-bind="true"
        @filterCallback="watchFilterCallback"
        @watchModalClose="watchModalClose"
    ></customer-filter>
</div>
</template>


<script>
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import ContactService from "~/services/contact";
import ProductService from "~/services/product";
import { Regexp } from "~/config/params";
import CustomerFilter from "~/widgets/CustomerFilter.vue";

export default {
    name: "ContactForm",
    components: {
        CustomerSelect,
        ContactService,
        ProductService,
        CustomerFilter
    },
    props: {
        customerId: "",
        contactId: "",
        isShowCustomerName: Boolean,   //从联系人列表进入编辑联系人需要展示客户名称，从客户详情页进入联系人编辑不需要展示客户名称
        isUpdateCustomerName: Boolean,
        customerName: "",
        contact: null,
        contactsList:{
            type: Array,
            default: [],
        },
    },
    data() {
        let validateMobile = (rule, value, callback) => {
            if(this.form.phone_number){
                callback();
            }
            if(!value){
                callback(new Error('手机和电话号码必须填写一个。'));
            }else{
                this.$refs.form.validateField('phone_number');
            }
            // if(!Regexp.mobile.test(value)){
            //     callback(new Error('联系人手机号码格式不正确。'));
            // }
            callback();
        };
        let validatePhoneNumber = (rule, value, callback) => {
            if(this.form.mobile){
                callback();
            }
            if(!value){
                callback(new Error('电话号码和手机必须填写一个。'));
            }
            // if(!Regexp.phone_number.test(value)){
            //     callback(new Error('联系人电话号码格式不正确，格式：区号-电话号码 或者 电话号码'));
            // }
            callback();
        };
        let validatejob = (rule, value, callback) => {
            if(!value){
                callback(new Error('请选择职务'));
            }
            if (this.form.job==4 && !this.form.job_name) {
                callback(new Error('请输职务名称'))
            }
            callback()
        };
        return {
            showCustomerFilter: false,
            loading: false,
            types: {},
            statuses: {},
            jobs: {},
            myProducts: [],
            contacts: [],
            // 分页信息
            regexp: {},
            title: '',
            //Dialog对话框所需要的变量 start
            isShow: true,
            form: ContactService.getModel(),
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入联系人姓名",
                        trigger: "blur"
                    },
                    {
                        min: 2,
                        max: 255,
                        message: "长度在 2 到 5 个字符",
                        trigger: "blur"
                    }
                ],
                mobile: [
                    {
                        validator: validateMobile,
                        trigger: "blur"
                    }
                ],
                phone_number: [
                    {
                        validator: validatePhoneNumber,
                        trigger: "blur"
                    }
                ],
                qq: [
                    {
                        required: false,
                        pattern: Regexp.qq,
                        message: "联系人QQ号码格式不正确",
                        trigger: "blur"
                    }
                ],
                type: [
                    {
                        required: true,
                        message: "请选择联系人类型",
                        trigger: "blur"
                    }
                ],
                // job: [
                //     {
                //         required: true,
                //         message: "请选择联系人职务",
                //         trigger: "blur"
                //     }
                // ],
                job: [
                    {
                        required: true,
                        validator: validatejob,
                        trigger: "blur"
                    }
                ],
                status: [
                    {
                        required: true,
                        message: "请选择是否关键联系人",
                        trigger: "blur"
                    }
                ],
                parent_id: [
                    {
                        required: true,
                        message: "请选择推荐人",
                        trigger: "change"
                    }
                ],
                products: [
                    {
                        required: true,
                        message: "请选择意向产品",
                    }
                ],
                customer_name: [
                    {
                        required: true,
                        message: "请选择客户",
                        trigger: "blur"                        
                    }
                ]
            },
            formLabelWidth: "100px",
            onlyShow:true,
        };
    },

    created: function() {
        this.types = ContactService.getTypes();
        this.statuses = ContactService.getStatuses();
        this.jobs = ContactService.getJobs();
        //获取上架的产品列表，新增/修改联系人意向产品选项
        if (this.myProducts.length == 0) {
            this.getProducts();
        }
        this.title = '新增联系人信息';
        this.form.id = '';
        this.form.customer_id = this.customerId;
        this.form.customer_name = this.customerName;
        if (this.contact && this.contact.id) {
            this.title = "修改联系人" + this.contact.name + "的信息";
            let products = [];
            if (this.contact.products && this.contact.products.length > 0) {
                this.contact.products.forEach((v, k) => {
                    if (v.product_id) {
                        let pid = v.product_id;
                        products.push(pid + '');
                    }
                })
            }

            this.form = Object.assign({}, this.form, this.contact);
            this.form.qq = this.form.qq + '';
            this.form.job = this.form.job + '';
            this.form.type = this.form.type + '';
            this.form.status = this.form.status + '';
            this.form.parent_id = this.form.parent_id + '';
            this.form.customer_name = this.customerName;
            this.form.products = products;

            // console.log(this.form.products);
        } else {
            this.getCurrentInfo();
        }
        if(this.form && this.form.job != 4){
            this.form.job_name = '';
        }
        // console.log('联系人信息11：', JSON.stringify(this.form), this.form.parent_id);
    },
    
    methods: {

        watchFilterCallback(customer) {
            this.form.customer_id = customer.id;
            this.form.customer_name = customer.name;
        },
        watchModalClose (isShow1) {
            this.showCustomerFilter = isShow1;
        },

        // 得到产品列表
        getProducts() {
            ProductService.getOptionList()
                .then(res => {
                    if (res && res.data) {
                        this.myProducts = res.data;
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },

        // 获取当前产品信息
        getCurrentInfo() {
            if (!this.contactId) return;
            ContactService.getCommonInfo(this.contactId).then( res => {
                if(res.code == 0) {
                    this.title = "修改联系人" + res.data.name + "的信息";
                    res.data.qq = res.data.qq == 0 ?  '' : res.data.qq;
                    res.data.job = res.data.job + '';
                    res.data.type = res.data.type + '';
                    res.data.status = res.data.status + '';
                    res.data.parent_id = res.data.parent_id + '';
                    this.form = Object.assign(this.form, res.data, {
                        customer_name: this.customerName
                    });
                    // console.log(this.form)
                }
            });
        },


        //表单提交确定按钮
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                if(this.form.status==1){
                    ContactService.check_contact(this.form.customer_id).then(res => {
                        if (res && res.data[0]) {
                            this.$confirm("该客户已经存在关键联系人，是否将现在的联系人设置为关键联系人？").then(_ => {
                                if (this.form.id) {
                                    this.update();
                                } else {
                                    this.create();
                                }
                            }).catch(_ => {});
                        }else{
                            if (this.form.id) {
                                this.update();
                            } else {
                                this.create();
                            }
                        }
                    });
                }else{
                    if (this.form.id) {
                        this.update();
                    } else {
                        this.create();
                    }
                }
            });
        },

        //创建联系人数据处理
        create() {
            this.loading = true;
            ContactService.create(this.form).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: "创建成功",
                        type: "success"
                    });
                    this.isShow = false;
                    this.$emit("changeShow", this.isShow);
                    //往上层组件传递数据,以实现新增后列表中增加展示新数据
                    this.$emit("changeCreate", res.data[0]);
                    this.$refs["form"].resetFields();
                }
                this.loading = false;
            });                   
        },

        //修改联系人数据处理
        update() {
            this.loading = true;
            ContactService.update(this.form).then(res => {
                if (res.code == 0) {
                    
                    this.$message({
                        message: "修改成功",
                        type: "success"
                    });
                    this.isShow = false;
                    this.$emit("changeShow", this.isShow);
                    //往上层组件传递数据,以实现编辑后列表数据立即更新
                    this.$emit("changeUpdate", {"form":this.form, "contact":res.data[0]}); 
                    this.$refs["form"].resetFields();
                }
                this.loading = false;
            });
        },


        // 关闭当前窗口
        close() {
            this.isShow = false;
            // 往上层组件传递更改后的状态
            this.$emit("changeShow", this.isShow);
            this.$refs["form"].resetFields();
        },        

        handleClose() {
            this.loading = false;
            this.close();
        },

        //客户名称远程搜索组件赋值
        CustomerHandleChange(object) {
            this.form.customer_id = object.value;
        },
        change() {
            this.$forceUpdate();
        }
        // //客户名称远程搜索组件赋值
        // jobsChange(val) {
        //     console.log('currStationChange', val)
        //     if (val == 4){

        //     }
        //     // if (object) {
        //     //     this.queryUnit(object)
        //     // } else {
        //     //     // 所属厂站没有值，清空操作单元的值
        //     //     this.formData.unitId = null
        //     //     // 所属厂站没有值，清空操作单元下拉框选项
        //     //     this.unitTree = []
        //     // }
        // }

    }
};


</script>


// WEBPACK FOOTER //
// src/views/contact/form.vue